import { render, staticRenderFns } from "./NoteSection.vue?vue&type=template&id=0f970d52&"
import script from "./NoteSection.vue?vue&type=script&lang=js&"
export * from "./NoteSection.vue?vue&type=script&lang=js&"
import style0 from "./NoteSection.vue?vue&type=style&index=0&id=0f970d52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports